import hoc from './hoc';
import instance from './PubSub';
import TOPICS from './topics';

export default { hoc, instance, TOPICS };
